import { useEffect } from "react";

import { useGetUser } from "../user-api";
import { useLazyGetSeasonsByLeagueQuery } from "./season-api";

export const useGetSeasonsByUserLeague = () => {
  const { user } = useGetUser();
  const [getSeasonsByLeague, seasons] = useLazyGetSeasonsByLeagueQuery();

  useEffect(() => {
    if (user) getSeasonsByLeague({ league: user.userDetails.leagueId });
  }, [user, getSeasonsByLeague]);

  return seasons;
};
